export const nArray = (n: number) => Array.from(Array(n).keys())

export function notNullOrUndefinedFilter<TValue>(
  value: TValue | null | undefined,
): value is TValue {
  return value !== null && value !== undefined
}

export const hasDefinedValues = (object: object) =>
  Object.values(object).filter(notNullOrUndefinedFilter).length > 0
